import React from "react"
import Utils from "../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"
import StaticPage from "../components/StaticPage/StaticPage"
import { createOverlay, createContentList } from "../contentfunctions/terms.js"

import Carousel1 from "../images/terms/terms-and-conditions-min.jpeg"

const TermsPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("en", "/terms", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.termsContent.item.content
        )
        const img = {
          src: Carousel1,
          altText: contentMap.seo_title.value,
          caption: contentMap.seo_description.value,
        }
        return (
          <StaticPage
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            img={img}
            originPage="terms"
            location={location}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            breadCrumbs={["menu_home", "menu_terms"]}
            createContentFun={createContentList}
            createOverlayFun={createOverlay}
            keywords={Utils.GetKeywordsFromTags(data.termsContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default TermsPage

const pageQuery = graphql`
  {
    termsContent: termsContentEngb {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentEngb {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
